import axios from 'axios'

const HTTP = axios.create({
  // baseURL: 'http://0.0.0.0:9092/api'
  // baseURL: 'http://api.mma.iono.top/api'
  // baseURL: 'http://api.butservice.iono.top',
  // baseURL: 'http://api.butservice.relekey.com',
  baseURL: 'https://api.butservice.com',
  // baseURL: 'http://localhost:8000',
  timeout: 600000
})

// let customerPortalUrl = 'http://localhost:5000'
let customerPortalUrl = 'http://customer-app.jadestatewealth.co.uk'

export { HTTP, customerPortalUrl }



// WEBPACK FOOTER //
// ./src/http-common.js